import React from 'react';
import { ActionTooltip, Button, Icon, Popup } from '@gravity-ui/uikit';
import { ImageForm } from '../../../forms/ImageForm';
import { i18n } from '../../../i18n/forms';
import { i18n as i18nToolbar } from '../../../i18n/menubar';
import { useBooleanState } from '../../../react-utils/hooks';
import { useToaster } from '../../../react-utils/toaster';
import { ToolbarTooltipDelay } from '../../../toolbar';
import { batchUploadFiles } from '../../../utils/upload';
import { icons } from '../../config/icons';
const placement = ['bottom-start', 'top-start', 'bottom-end', 'top-end'];
export const ToolbarImage = ({ className, active, enable, onSubmit, focus, onClick, uploadImages, onSuccessUpload, }) => {
    var _a;
    const toaster = useToaster();
    const buttonRef = React.useRef(null);
    const [open, , hide, toggleOpen] = useBooleanState(false);
    const [loading, showLoading, hideLoading] = useBooleanState(false);
    const popupOpen = enable && open;
    const shouldForceHide = open && !popupOpen;
    React.useLayoutEffect(() => {
        if (shouldForceHide) {
            hide();
        }
    }, [hide, shouldForceHide]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionTooltip, { disabled: popupOpen, title: i18nToolbar('image'), openDelay: ToolbarTooltipDelay.Open, closeDelay: ToolbarTooltipDelay.Close },
            React.createElement(Button, { size: "m", ref: buttonRef, view: active || popupOpen ? 'normal' : 'flat', selected: active, disabled: !enable, className: className, onClick: toggleOpen },
                React.createElement(Icon, { data: icons.image.data, size: (_a = icons.image.size) !== null && _a !== void 0 ? _a : 16 }))),
        React.createElement(Popup, { anchorRef: buttonRef, open: popupOpen, onClose: hide, placement: placement },
            React.createElement(ImageForm, { autoFocus: true, onAttach: uploadImages &&
                    ((files) => {
                        showLoading();
                        batchUploadFiles(files, uploadImages).then((res) => {
                            hideLoading();
                            hide();
                            onSuccessUpload === null || onSuccessUpload === void 0 ? void 0 : onSuccessUpload(res);
                        }, (err) => {
                            hideLoading();
                            toaster.add({
                                theme: 'danger',
                                name: 'toolbar_image_upload',
                                title: i18n('image_upload_failed'),
                                content: String(err),
                            });
                        });
                    }), onCancel: hide, onSubmit: (data) => {
                    hide();
                    focus();
                    onSubmit(data);
                    onClick === null || onClick === void 0 ? void 0 : onClick('addImage');
                }, loading: loading }))));
};
